import { jsx as _jsx } from "react/jsx-runtime";
import { m } from 'framer-motion';
export function MarkerMotionAnimation({ children }) {
    return (_jsx(m.div, { initial: { scale: 0.75, opacity: 0 }, animate: { scale: 1, opacity: 1 }, exit: { scale: 0.75, opacity: 0 }, transition: { duration: 0.2 }, children: children }));
}
